import './image-comp.css';

import * as React from 'react';

const folderPath = 'https://betting-books.stevedavo.com/resources/banners/';

interface IImageCompProps {
  imageName: string;
  height: string;
  alt?: string;
}

// TypeScript 2.8's img type has no loading attribute, so it is passed by spread
const lazyLoading: any = { loading: 'lazy', decoding: 'async' };

export const ImageComp: React.SFC<IImageCompProps> = props => (
  <img
    className="image-comp-img"
    style={{ height: props.height }}
    src={folderPath + props.imageName}
    alt={props.alt || ''}
    {...lazyLoading}
  />
);
